import React from 'react';

import { Alert, Anchor, Text } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useHref } from 'react-router';
import { ROUTE_LINKS } from 'shared/constants/route-links';

export function OutOfFreePhoneNumbersAlert() {
  const { t } = useTranslation();
  const pricingHref = useHref(ROUTE_LINKS.billing);

  return (
    <Alert color="yellow" icon={<IconAlertTriangle />}>
      <Text size="sm" weight={500}>
        {t('SMART_ASSISTANT.TELEPHONY_SECTION.PURCHASE_MODAL.OUT_OF_FREE_PHONE_NUMBERS_ALERT.TITLE')}
      </Text>
      <Text size="xs">
        {t('SMART_ASSISTANT.TELEPHONY_SECTION.PURCHASE_MODAL.OUT_OF_FREE_PHONE_NUMBERS_ALERT.DESCRIPTION')}{' '}
        <Anchor href={pricingHref} target="_blank" rel="noopener noreferrer" inherit>
          {t('APP.ACTIONS.UPGRADE_PLAN')}
        </Anchor>
      </Text>
    </Alert>
  );
}
